import { ReactNode } from "react";
import CopyText from "../CopyText";
import { ProTooltip } from '../antd';
import classNames from "classnames";
import { OptionItem } from "./interface";
import { TooltipProps } from 'antd/lib/tooltip';
import { TABLE_COLUMN_EMPTY } from '../constants/constant'

const URL_MAP: any = {
  JP: 'co.jp',
  CA: 'ca',
  US: 'com',
  MX: 'com.mx',
  BR: 'com.br',
  ES: 'es',
  GB: 'co.uk',
  FR: 'fr',
  NL: 'nl',
  DE: 'de',
  IT: 'it',
  TR: 'com.tr',
  AE: 'ae',
  IN: 'in',
  SG: 'com.sg',
  AU: 'com.au',
  SE: 'se',
  PL: 'pl',
  EG: 'me',
  BE: 'com.be',
};

export function renderValueHtml(item: OptionItem): ReactNode {
  const { renderType, countryCode, value, linkUrl, copy, style, className, tooltipProps, copyTextProps, } = item;
  const classes = classNames('good-info-column-info-item-text', className);
  if (renderType) {
    if (renderType === 'Asin') {
      if (countryCode && URL_MAP[countryCode] && value) {
        return (
          <a
            href={`https://www.amazon.${URL_MAP[countryCode]}/dp/${value}`}
            target="_blank"
            style={style}
          >
            {value || TABLE_COLUMN_EMPTY}
          </a>
        );
      }
      if (tooltipProps) {
        const newTooltipProps: TooltipProps = typeof tooltipProps === 'string' ? { title: tooltipProps } : tooltipProps;
        return (
          <ProTooltip {...newTooltipProps}>
            <span className={classes} style={style}>{value}</span>
          </ProTooltip>
        );
      }
      return (
        <span className={classes} style={style}>{value || TABLE_COLUMN_EMPTY}</span>
      );
    }
  }
  if (linkUrl && value) {
    return (
      <a
        href={linkUrl}
        target="_blank"
        style={style}
      >
        {value}
      </a>
    );
  }
  if (copy && typeof value === 'string') {
    return (
      <CopyText text={value} {...copyTextProps} />
    );
  }
  if (tooltipProps) {
    const newTooltipProps: TooltipProps = typeof tooltipProps === 'string' ? { title: tooltipProps } : tooltipProps;
    return (
      <ProTooltip {...newTooltipProps}>
        <span className={classes} style={style}>{value}</span>
      </ProTooltip>
    );
  }
  return (
    <span className={classes} style={style}>{value || TABLE_COLUMN_EMPTY}</span>
  );
};